<template>
  <div class="font-regular font-inter text-xs leading-4 text-gray-100">
    <p>
      <slot />
    </p>
  </div>
</template>
<script lang="ts" setup></script>
<style lang="scss"></style>
